import React from "react";
import _ from "lodash";
import cx from "classnames";
import ModalFooter from "../../../../parts/modals/ModalFooter";
import RangeInput from "../../../../parts/inputs/range-input";
import PercentInput from "../../../../parts/inputs/percent-input";
import FilterExercisesModal from "../../../../parts/modals/filter-exercises";
import Modal from "../../../../parts/modal-new";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";

const {
  CUSTOM_METRIC_CUMULATIVE,
  CUSTOM_METRIC_GROUPS,
  CUSTOM_METRIC_DATA_SERIES,
  PERIOD_FORMATS,
  ZONES,
  PRIMARIES,
  DATE_FORMATS: { DATE_PICKER_FORMAT },
} = require("../../../../constants");

class View extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.state = this.getDefaultState();
    this.handleFormReset = this.handleFormReset.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleBarChartChange = this.handleBarChartChange.bind(this);
    this.handleBarGroupChange = this.handleBarGroupChange.bind(this);
    this.handleLineChartChange = this.handleLineChartChange.bind(this);
  }

  getDefaultState() {
    const exerciseType = _.get(
      this,
      "context.locals.editCustomMetric.filters.type"
    );
    const showExerciseFilters = !exerciseType || exerciseType === "secondary";
    const activeLineRelation = _.get(
      this,
      "context.locals.editCustomMetric.data.line.relation"
    );
    const barSeries = _.get(
      this,
      "context.locals.editCustomMetric.data.bar.series"
    );
    const barGroup = _.get(
      this,
      "context.locals.editCustomMetric.data.bar.group"
    );
    const lineOptions = _.get(
      _.find(CUSTOM_METRIC_DATA_SERIES, { value: activeLineRelation }),
      "series"
    );
    return {
      lineOptions,
      barSeries,
      barGroup,
      showExerciseFilters,
    };
  }

  handleFormReset() {
    this.setState(this.getDefaultState());
  }

  handleTypeChange({ target: { value } }) {
    this.setState({ showExerciseFilters: !value || value === "secondary" });
  }

  handleBarGroupChange({ target: { selectedIndex, options } }) {
    const $selected = options[selectedIndex];
    this.setState({ barGroup: _.get($selected, "value") });
  }

  handleBarChartChange({ target: { value } }) {
    this.setState({ barSeries: value });
  }

  handleLineChartChange({ target: { selectedIndex, options } }) {
    const { value } = options[selectedIndex];
    this.setState({
      lineOptions: _.get(
        _.find(CUSTOM_METRIC_DATA_SERIES, { value }),
        "series"
      ),
      lineSelectionChanged: true,
    });
  }

  render() {
    const { state } = this;
    const { locals } = this.context;
    const { editCustomMetric, activeUser, query } = locals;
    const organizationCoach = locals.query.organizationCoach || undefined;
    const organizationCoachParam = organizationCoach
      ? `&organizationCoach=${organizationCoach}`
      : "";
    const { lineOptions, barSeries, barGroup, showExerciseFilters } = state;
    const activeID = _.get(editCustomMetric, "_id", "");
    const activeName = _.get(editCustomMetric, "name", "");
    const activeBarSeries = _.get(editCustomMetric, "data.bar.series", "");
    const activeLineRelation = _.get(
      editCustomMetric,
      "data.line.relation",
      ""
    );
    const activeLineSeries = _.get(editCustomMetric, "data.line.series");
    const activeType = _.get(editCustomMetric, "filters.type", "");
    const activeRPEMin = _.get(editCustomMetric, "filters.rpe.min", 1);
    const activeRPEMax = _.get(editCustomMetric, "filters.rpe.max", 10);
    const activeUnassignedRPE = _.get(
      editCustomMetric,
      "filters.rpe.unassigned",
      "checked"
    );
    const activeIntensityMin = _.get(
      editCustomMetric,
      "filters.intensity.min",
      ""
    );
    const activeIntensityMax = _.get(
      editCustomMetric,
      "filters.intensity.max",
      ""
    );
    const activeMovement = _.get(editCustomMetric, "filters.primary", "");
    const activeLiftType = _.get(editCustomMetric, "filters.liftType", "");
    const activeZones = _.get(editCustomMetric, "filters.zones", ZONES);
    const activeEquipment = _.get(editCustomMetric, "filters.equipment", "");
    const activeSecondaries = _.get(editCustomMetric, `filters.secondaries`);
    const isNew = !activeID;

    return (
      <main role="reports-wrapper">
        <Modal
          title="Create custom report"
          className="create-custom-report"
          onClose={() =>
            submit(
              "/athlete-portal/metrics/custom/list?athlete=${query.athlete}"
            )
          }
        >
          <div className="body">
            <form
              className="Main Custom-Reports"
              method="POST"
              action={`/actions/custom-metrics/save/${activeID}?athlete=${query.athlete}${organizationCoachParam}`}
              onReset={this.handleFormReset}
              data-noreset
              id="create-custom-report"
            >
              <input
                type="hidden"
                name="filters[secondaries]"
                value={JSON.stringify(activeSecondaries)}
              />
              <div className="CMR-Options">
                {/* <div className="CMR-Head bottom-space">
                  <h2>Create custom report</h2>
                </div> */}
                <section>
                  <div>
                    <label>Report Name</label>
                    <input
                      type="text"
                      name="name"
                      defaultValue={activeName}
                      required
                      placeholder="Enter a name for the report"
                    />
                  </div>
                </section>

                <section>
                  <div className="y-axis">
                    <label className="label alt">Bar Chart</label>
                    <div className="">
                      <div className="axis-box" data-col="1/1">
                        <select
                          name="data[bar][series]"
                          className="select-input"
                          defaultValue={activeBarSeries}
                          onChange={this.handleBarChartChange}
                        >
                          <option value="">Select a Data Series</option>
                          {_(CUSTOM_METRIC_DATA_SERIES)
                            .flatMap("series")
                            .map(({ title, value }) => {
                              return (
                                <option key={value} value={value}>
                                  {title}
                                </option>
                              );
                            })
                            .value()}
                        </select>
                      </div>
                      <div className="axis-box">
                        {_.includes(CUSTOM_METRIC_CUMULATIVE, barSeries) && (
                          <select
                            name="data[bar][group]"
                            className="select-input"
                            value={barGroup}
                            onChange={this.handleBarGroupChange}
                          >
                            <option value="">
                              Stack bar chart by (optional)
                            </option>
                            {_.map(CUSTOM_METRIC_GROUPS, ({ title, value }) => {
                              return (
                                <option key={title} value={value}>
                                  {title}
                                </option>
                              );
                            })}
                          </select>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="z-axis">
                    <label className="label alt">Line Chart</label>
                    <div className="">
                      <div className="axis-box">
                        <select
                          name="data[line][relation]"
                          ref="select_line"
                          className="select-input"
                          defaultValue={activeLineRelation}
                          onChange={this.handleLineChartChange}
                        >
                          <option value="">Select a Data Series</option>
                          {_.map(
                            CUSTOM_METRIC_DATA_SERIES,
                            ({ title, value }) => {
                              if (
                                barSeries === "lifts-total" &&
                                value === "lifts"
                              )
                                return;
                              return (
                                <option key={title} value={value}>
                                  {title}
                                </option>
                              );
                            }
                          )}
                        </select>
                      </div>

                      <div className="axis-box list" data-col="1/1">
                        {_(lineOptions)
                          .reject({ value: barSeries })
                          .map(({ title, value }) => {
                            // checked if its a new report or if retrieved from a stored report or if the selection box changes
                            const isChecked =
                              activeID == "" ||
                              _.isEmpty(activeLineSeries) ||
                              this.state.lineSelectionChanged
                                ? "checked"
                                : _.includes(activeLineSeries, value);
                            return (
                              <label key={value} className="checkbox-input">
                                <input
                                  name="data[line][series][]"
                                  type="checkbox"
                                  defaultChecked={isChecked}
                                  value={value}
                                />
                                <span className="checkbox" />
                                <span className="text">{title}</span>
                              </label>
                            );
                          })
                          .value()}
                      </div>
                    </div>
                  </div>
                </section>

                <section>
                  <div className="exercise-type-wrapper bottom-space">
                    <label>Exercise Type</label>
                    <div className="Conditional-Display">
                      <input
                        type="radio"
                        id="toggle-type-all"
                        name="filters[type]"
                        value=""
                        defaultChecked={!activeType}
                        onChange={this.handleTypeChange}
                      />
                      {barGroup !== "by-primary-secondary" && (
                        <input
                          type="radio"
                          id="toggle-type-primary"
                          name="filters[type]"
                          value="primary"
                          defaultChecked={activeType === "primary"}
                          onChange={this.handleTypeChange}
                        />
                      )}
                      {barGroup !== "by-primary-secondary" && (
                        <input
                          type="radio"
                          id="toggle-type-secondary"
                          name="filters[type]"
                          value="secondary"
                          defaultChecked={activeType === "secondary"}
                          onChange={this.handleTypeChange}
                        />
                      )}
                      <div className="options list-wrapper">
                        <label
                          className="option radio-input"
                          htmlFor="toggle-type-all"
                        >
                          <span className="radio" />
                          <span className="text">All</span>
                        </label>
                        {barGroup !== "by-primary-secondary" && (
                          <label
                            className="option radio-input"
                            htmlFor="toggle-type-primary"
                          >
                            <span className="radio" />
                            <span className="text">Primary</span>
                          </label>
                        )}
                        {barGroup !== "by-primary-secondary" && (
                          <label
                            className="option radio-input"
                            htmlFor="toggle-type-secondary"
                          >
                            <span className="radio" />
                            <span className="text">Secondary</span>
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                  <div>
                    <label>RPE Filter</label>
                    <div className="rpe-filter-wrapper">
                      <RangeInput
                        minName="filters[rpe][min]"
                        maxName="filters[rpe][max]"
                        min={5}
                        max={10}
                        step={1}
                        defaultValue={[activeRPEMin, activeRPEMax]}
                      />
                      <label className="checkbox-input rpe-unassigned">
                        <input
                          type="checkbox"
                          name="filters[rpe][unassigned]"
                          value="true"
                          defaultChecked={activeUnassignedRPE}
                        />
                        <span className="checkbox" />
                        <span className="text">Include Unassigned RPE</span>
                      </label>
                    </div>
                  </div>
                  <div className="">
                    <label>Intensity Range</label>
                    <div className="percent-input-wrapper">
                      <PercentInput
                        className="sm"
                        name="filters[intensity][min]"
                        defaultValue={activeIntensityMin}
                        placeholder="Min"
                      />
                      <span className="text-between">to</span>
                      <PercentInput
                        className="sm"
                        name="filters[intensity][max]"
                        defaultValue={activeIntensityMax}
                        placeholder="Max"
                      />
                    </div>
                  </div>
                </section>

                <section>
                  <div className="lift-priority-wrapper">
                    <label>Lift Priority</label>
                    <div className="Conditional-Display">
                      {_.map(["all"].concat(PRIMARIES), (primary) => {
                        const isAll = primary === "all";
                        const value = isAll ? "" : primary;
                        const isActive = isAll
                          ? !activeMovement
                          : activeMovement === value;
                        return (
                          <input
                            type="radio"
                            name="filters[primary]"
                            id={`movement-${primary}`}
                            value={value}
                            defaultChecked={isActive}
                          />
                        );
                      })}
                      <div className="options list-wrapper">
                        {_.map(["all"].concat(PRIMARIES), (primary) => {
                          return (
                            <label
                              key={primary}
                              className="option radio-input"
                              htmlFor={`movement-${primary}`}
                            >
                              <span className="radio" />
                              <span className={`text ${primary}`}>
                                {_.capitalize(primary)}
                              </span>
                            </label>
                          );
                        })}
                        <div className="displays">
                          <div className="display">
                            {showExerciseFilters && (
                              <a
                                href={`/actions/refresh?modal[type]=filter-exercises`}
                              >
                                <SvgIcon src="/img/new-icons/filter-white.svg" />{" "}
                                Filter Exercises
                              </a>
                            )}
                          </div>
                          {_.map(PRIMARIES, (primary) => {
                            if (
                              !showExerciseFilters ||
                              _.isEmpty(
                                _.get(activeUser, `exerciseLibrary.${primary}`)
                              )
                            ) {
                              return <div key={primary} className="display" />;
                            }
                            return (
                              <div key={primary} className="display">
                                <a
                                  href={`/actions/refresh?modal[type]=filter-exercises&modal[primary]=${primary}`}
                                >
                                  <SvgIcon src="/img/new-icons/filter-white.svg" />{" "}
                                  Filter Exercises
                                </a>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="lift-type-wrapper">
                    <label>Lift Type</label>

                    <div className="Conditional-Display">
                      <input
                        type="radio"
                        name="filters[liftType]"
                        id="lift-all"
                        value=""
                        defaultChecked={!activeLiftType}
                      />
                      {barGroup !== "by-raw-equipped" && (
                        <input
                          type="radio"
                          name="filters[liftType]"
                          id="lift-raw"
                          value="raw"
                          defaultChecked={activeLiftType === "raw"}
                        />
                      )}
                      {barGroup !== "by-raw-equipped" && (
                        <input
                          type="radio"
                          name="filters[liftType]"
                          id="lift-equipped"
                          value="equipped"
                          defaultChecked={activeLiftType === "equipped"}
                        />
                      )}

                      <div className="options list-wrapper">
                        <label
                          className="option radio-input"
                          htmlFor="lift-all"
                        >
                          <span className="radio" />
                          <span className="text">All</span>
                        </label>
                        {barGroup !== "by-raw-equipped" && (
                          <label
                            className="option radio-input"
                            htmlFor="lift-raw"
                          >
                            <span className="radio" />
                            <span className="text">Raw</span>
                          </label>
                        )}
                        {barGroup !== "by-raw-equipped" && (
                          <label
                            className="option radio-input"
                            htmlFor="lift-equipped"
                          >
                            <span className="radio" />
                            <span className="text">Equipped</span>
                          </label>
                        )}
                        <label>
                          <input
                            type="text"
                            name="filters[equipment]"
                            placeholder="Equipment"
                            className="text-input"
                            defaultValue={activeEquipment}
                          />
                        </label>
                      </div>

                      {/* <div className="displays">
                        <div className="display" />
                        <div className="display" />
                        <div className="display">
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div>
                    <label>Zone of Relative Intensity</label>
                    <div className="options list-wrapper">
                      {_.map(ZONES, (zone) => {
                        const isActive = _.includes(activeZones, zone);
                        return (
                          <label key={zone} className="checkbox-input">
                            <input
                              type="checkbox"
                              name="filters[zones][]"
                              value={zone}
                              defaultChecked={isActive}
                            />
                            <span className="checkbox" />
                            <span className={cx("text", zone)}>
                              {_.capitalize(zone)}
                            </span>
                          </label>
                        );
                      }).reverse()}
                    </div>
                  </div>
                </section>
                {/* <ModalFooter
                  showAltButton={!isNew}
                  hrefAltButton={`/actions/custom-metrics/remove/${activeID}?athlete=${query.athlete}`}
                  altButtonText="Delete"
                  extraAltButton={
                    <div className="column">
                    <a
                    className="button alt"
                    href={`/athlete-portal/metrics/custom/list?athlete=${query.athlete}`}
                    >
                    Cancel
                    </a>
                    </div>
                  }
                  isSubmitButton={true}
                  buttonText={`${isNew ? "Create" : "Save"} & View`}
                /> */}
              </div>
            </form>
          </div>
          <footer>
            <button
              type="submit"
              form="create-custom-report"
              data-button-type="primary"
            >{`${isNew ? "Create" : "Save"} & View`}</button>
          </footer>
        </Modal>
      </main>
    );
  }
}

const EditController = (app) => {
  app.get("/edit/:customMetric?", async ({ req, res, locals, load }) => {
    const { params, query } = req;
    const editCustomMetric = await load("editCustomMetric", {
      customMetric: params.customMetric,
      proxyAthlete: query.athlete,
    });

    locals.title = locals.title.concat(
      _.isEmpty(editCustomMetric)
        ? "Create Custom Metrics"
        : `Edit ${editCustomMetric.name}`
    );

    const modal = _.get(query, "modal", {});
    if (modal.type === "filter-exercises") {
      // Remove selected secondaries if we have changed primary.
      const primary = _.get(editCustomMetric, "filters.primary");
      if (primary && modal.primary !== primary) {
        _.unset(editCustomMetric, "filters.secondaries");
      }
    }
    locals.modal = {
      "filter-exercises": <FilterExercisesModal />,
    }[modal.type];

    res.body = <View />;
  });
};

export default EditController;
